import { YesNoState, SportsCardType, SportsCardCondition, SportsCardPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  sports_card_type: {
    friendly: 'Type',
    validations: {
      type: 'enum',
      enumType: SportsCardType,
    },
  },

  sports_card_player: {
    friendly: 'Player',
    validations: {
      maxLength: 255,
    },
  },

  sports_card_position: {
    friendly: 'Position',
    validations: {
      maxLength: 255,
    },
  },

  sports_card_player_number: {
    friendly: 'Player No.',
    validations: {
      maxLength: 255,
    },
  },

  sports_card_team: {
    friendly: 'Team',
    validations: {
      maxLength: 255,
    },
  },

  sports_card_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  sports_card_manufucturer: {
    friendly: 'Manufucturer',
    validations: {
      maxLength: 255,
    },
  },

  sports_card_set: {
    friendly: 'Set',
    validations: {
      maxLength: 255,
    },
    typeHint: typeHints.TextArea,
  },

  sports_card_no: {
    friendly: 'Card No.',
    validations: {
      maxLength: 255,
    },
  },

  sports_card_signed: {
    friendly: 'Signed',
    validations: {
      type: 'enum',
      enumType: YesNoState,
    },
  },

  sports_card_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: SportsCardCondition,
    },
  },

  sports_card_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: SportsCardPurchaseCondition,
    },
  },

  sports_card_grade: {
    friendly: 'Grade',
    validations: {
      maxLength: 255,
    },
  },

};

export default attributes;

export const SportsCardDefaultSplitAttribute = 'sports_card_type';

export const SportsCardItemSearchAttributes = [];

export const SportsCardOverviewAttributes = ['title', 'sports_card_type', 'sports_card_manufucturer', 'sports_card_year', 'sports_card_condition',
  'sports_card_grade', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const SportsCardSpecificationAttributes = ['sports_card_player', 'sports_card_position', 'sports_card_player_number', 'sports_card_team',
  'sports_card_set', 'sports_card_no', 'sports_card_signed'];

export const SportsCardPurchaseAttributes = ['purchase_date', 'purchase_price', 'sports_card_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const SportsCardDetailAttributes = [];

export const SportsCardRequiredAttributes = [];

export const SportsCardDisplayAttributes = ['sports_card_type', 'sports_card_player', 'sports_card_team', 'sports_card_manufucturer', 'tags'];

export const SportsCardSliderGalleryAttributes = {
  titleKey: 'sports_card_type',
  subtitleKey: 'sports_card_player',
};



// WEBPACK FOOTER //
// ./src/config/sportsCardDataAttributes.js